export class DuplicatedNfError extends Error {
  constructor(nfs: string[]) {
    super(
      `As notas fiscais: ${nfs.join(
        " "
      )} já foram inseridas em outro Recebimento!`
    );
    this.name = "DuplicatedNfError";
  }
}
